import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg, sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);


export const selectStyles = css`
    :host {
      position: relative;

      --select__color: var(--_select__color, var(--sbkSelectColorFgColorOnLightDefault));
      --select__color--disabled: var(--_select__color--disabled, var(--sbkSelectColorFgColorOnLightDisabled));
      --select__color--error: var(--_select__color--error, var(--sbkSelectColorFgColorOnLightError));

      --select__bg: var(--_select__bg, var(--sbkSelectColorBgColorOnLightTriggerEnabled));
      --select__bg--active: var(--_select__bg--active, var(--sbkSelectColorBgColorOnLightTriggerActive));
      --select__bg--hover: var(--_select__bg--hover, var(--sbkSelectColorBgColorOnLightTriggerHover));
      --select__bg--focus: var(--_select__bg--focus, var(--sbkSelectColorBgColorOnLightTriggerFocus));
      --select__bg--disabled: var(--_select__bg--disabled, var(--sbkSelectColorBgColorOnLightTriggerDisabled));
      --select__bg--error: var(--_select__bg--error, var(--sbkSelectColorBgColorOnLightTriggerError));

      --select__border: var(--_select__border, var(--sbkSelectBorderOnLightEnabled));
      --select__border--active: var(--_select__border--active, var(--sbkSelectBorderOnLightActive));
      --select__border--disabled: var(--_select__border--disabled, var(--sbkSelectBorderOnLightDisabled));
      --select__border--error: var(--_select__border--error, var(--sbkSelectBorderOnLightError));
      --select__border--focus: var(--_select__border--focus, var(--sbkSelectBorderOnLightFocus));
      --select__border--hover: var(--_select__border--hover, var(--sbkSelectBorderOnLightHover));
      --select__border--readonly: var(--_select__border--readonly, var(--sbkSelectBorderOnLightDisabled));


      --select-flyout__bg: var(--_select__bg, var(--sbkSelectColorBgColorOnLightFlyoutEnabled));
      --select-flyout__box-shadow: var(--_select-flyout__box-shadow, var(--sbkSelectFlyoutOnLightShadow));

      --_input__color: var(--sbkInputFgColorOnLightDefault);
      --_input__color--disabled: var(--sbkInputFgColorOnLightDisabled);
      --_input__color--error: var(--sbkInputFgColorOnLightError);

      --_input__bg: var(--sbkInputBgColorOnLightEnabled);
      --_input__bg--active: var(--sbkInputBgColorOnLightActive);
      --_input__bg--hover: var(--sbkInputBgColorOnLightHover);
      --_input__bg--focus: var(--sbkInputBgColorOnLightFocus);
      --_input__bg--disabled: var(--sbkInputBgColorOnLightDisabled);
      --_input__bg--error: var(--sbkInputBgColorOnLightError);

      --_input__border: var(--sbkInputBorderOnLightEnabled);
      --_input__border--active: var(--sbkInputBorderOnLightActive);
      --_input__border--disabled: var(--sbkInputBorderOnLightDisabled);
      --_input__border--error: var(--sbkInputBorderOnLightError);
      --_input__border--focus: var(--sbkInputBorderOnLightFocus);
      --_input__border--hover: var(--sbkInputBorderOnLightHover);
      --_input__border--readonly: var(--sbkInputBorderOnLightDisabled);

      --_input__margin-bottom: 0;
    }

  * {
    box-sizing: border-box;
  }

  .input__wrapper {
    margin-bottom: var(--sbkCoreSpacingMd);
    width: 100%;
  }

  .input__wrapper--error {
    .select-input {
      background-color: var(--select__bg--error);
      border: var(--select__border--error);
      color: var(--select__color--error);
    }
  }

  .select-menu__wrapper {
    display: block;
    position: relative;

    .label__wrapper + sbk-annotation {
        margin-top: calc(var(--sbkInput3xs) * -1);
        margin-bottom: var(--sbkInput3xs);
    }
  }

  .select-input {
    background-color: var(--select__bg);
    border: var(--select__border);
    border-radius: var(--sbkSelectBorderRadiusDefault);
    color: var(--select__color);
    font: var(--sbkSelectTypographySelectSmallTextSm);
    outline: transparent;
    outline-offset: var(--sbkSelectBorderGapFocus);
    padding: var(--sbkInput2xs);
    position: relative;
    cursor: pointer;

    @media all and (min-width: ${breakpointLg}) {
      font: var(--sbkSelectTypographySelectLargeTextLg);
      padding: var(--sbkInputXs);
    }

    &:active {
      background-color: var(--select__bg--active);
      border: var(--select__border--active);
    }

    &:focus {
      background-color: var(--select__bg--focus);
      outline: var(--select__border--focus);
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover:not(:focus) {
        background-color: var(--select__bg--hover);
        border: var(--select__border--hover);
      }
    }

    &[disabled] {
      background-color: var(--select__bg--disabled);
      border: var(--select__border--disabled);
      color: var(--select__color--disabled);
      cursor: not-allowed;
      pointer-events: none;
    }

    &[readonly] {
      background-color: var(--select__bg--disabled);
      border: var(--select__border--readonly);
      color: var(--select__color--disabled);
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  .select__icon-wrapper {
    position: absolute;
    right: var(--sbkInput2xs);
    top: calc(50% - var(--sbkInput2xs));

  }

  sbk-badge{
    position: absolute;
    right: 0;
    top: 30%;
    margin-right: 3rem;
  }

  .select__text-wrapper {
    margin-right: calc(var(--sbkSelectSpacingXs) + var(--sbkSelectSpacing2xs));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media all and (max-width: calc(${breakpointMd} - 1px)) {
      font-size: 13px;
    }
  }

  .select__text-wrapper--empty-option {
    color: var(--select__color--disabled)
  }

  .select__search-wrapper {
    padding: var(--sbkSelectSpacingXs);
    background-color: var(--select-flyout__bg);
  }

  .select-menu {
    background-color: var(--select-flyout__bg);
    border-radius: var(--sbkSelectBorderRadiusDefault);
    display: none;
    left: 0;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 100;
    margin-top: var(--sbkSelectSpacing3xs);
    box-shadow: var(--select-flyout__box-shadow);
  }

  .select__listbox {
    position: relative;
    overflow-y: auto;
    max-height: 300px;
  }

  .select--open .select-menu {
    display: block;
  }

  .select-no-option {
    font: var(--sbkSelectTypographyFlyoutSm);
    color: var(--sbkSelectColorFgColorOnLightDisabled);
    padding: var(--sbkSelectSpacingXs);
  }

`;
